var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOfficeDocIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.43351 0H8.69734L14 5.31794V15.6595C14 16.951 12.9092 18 11.5629 18H2.43354C1.09076 18 3.84856e-10 16.951 3.84856e-10 15.6595V2.34045C-2.36471e-05 1.04904 1.09074 0 2.43351 0Z",
    fill: "#0263D1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.69013 0V5.27641H14L8.69013 0Z",
    fill: "#CCCCCC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.46771 9.36528H4.53225C4.30544 9.36528 4.11825 9.1887 4.11825 8.97059C4.11825 8.75249 4.30544 8.57591 4.53225 8.57591H9.46771C9.69451 8.57591 9.87808 8.75249 9.87808 8.97059C9.87808 9.1887 9.69451 9.36528 9.46771 9.36528ZM7.82255 14.112H4.53225C4.30544 14.112 4.11825 13.9354 4.11825 13.7173C4.11825 13.4992 4.30544 13.3226 4.53225 13.3226H7.82255C8.04936 13.3226 8.23293 13.4992 8.23293 13.7173C8.23293 13.9354 8.04936 14.112 7.82255 14.112ZM9.46771 12.5297H4.53225C4.30544 12.5297 4.11825 12.3532 4.11825 12.135C4.11825 11.9169 4.30544 11.7404 4.53225 11.7404H9.46771C9.69451 11.7404 9.87808 11.9169 9.87808 12.135C9.87808 12.3532 9.69451 12.5297 9.46771 12.5297ZM9.46771 10.9475H4.53225C4.30544 10.9475 4.11825 10.7709 4.11825 10.5528C4.11825 10.3347 4.30544 10.1581 4.53225 10.1581H9.46771C9.69451 10.1581 9.87808 10.3347 9.87808 10.5528C9.87808 10.7709 9.69451 10.9475 9.46771 10.9475Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeDocIcon);
export default __webpack_public_path__ + "static/media/OfficeDocIcon.931dd0ec6cb7eb7394422330c70184f4.svg";
export { ForwardRef as ReactComponent };